module.exports = __webpack_public_path__ + "img/header_bg.35fb2192.png";